import React from 'react';
import { ArenaLeaderboardRow } from '../../../api/group/arena.api';

interface Props {
  rows: ArenaLeaderboardRow[];
  myTeamId?: string | null;
  hidePoints?: boolean;
}

const ArenaLeaderboard: React.FC<Props> = ({ rows, myTeamId, hidePoints }) => (
  <div className="overflow-x-auto rounded-[16px] border border-[#DEE0E6] dark:border-slate-700">
    <table className="w-full text-left text-[14px]">
      <thead className="bg-[#F1F5F9] text-[#475569] dark:bg-slate-800 dark:text-slate-300">
        <tr>
          <th className="px-4 py-2">Hạng</th>
          <th className="px-4 py-2">Tên đội</th>
          <th className="px-4 py-2">Điểm cuối</th>
          {!hidePoints && <th className="px-4 py-2">Điểm nhận</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr
            key={r.teamId}
            className={`border-t border-[#DEE0E6] dark:border-slate-700 ${
              r.teamId === myTeamId ? 'bg-[#EFF6FF] dark:bg-slate-800' : ''
            }`}
          >
            <td className="px-4 py-2 font-semibold text-[#19052f] dark:text-slate-100">
              {r.disqualified ? '-' : r.rank ?? '-'}
            </td>
            <td className="px-4 py-2 text-[#19052f] dark:text-slate-100">
              <span>{r.teamName}</span>
              {r.disqualified && (
                <span className="ml-2 text-[12px] text-[#E11D48]">
                  Bị loại{r.disqualifyReason ? `: ${r.disqualifyReason}` : ''}
                </span>
              )}
            </td>
            <td className="px-4 py-2 dark:text-slate-200">
              {r.finalScore == null ? '-' : r.finalScore.toLocaleString('vi-VN', { maximumFractionDigits: 1 })}
            </td>
            {!hidePoints && <td className="px-4 py-2 dark:text-slate-200">{r.points}</td>}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default ArenaLeaderboard;
